<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-icon-button disabled></button>
      <button *ngIf="node.selected" mat-flat-button (click)="folderClick(node)" class="selected-button">{{node.displayName}}</button>
      <div *ngIf="!node.selected" style="cursor: pointer;" (click)="folderClick(node)">{{node.displayName}}</div>
    </mat-tree-node>
  
    <mat-tree-node *matTreeNodeDef="let node; when hasChild" matTreeNodePadding style="min-height: 20px;">
      <button mat-icon-button matTreeNodeToggle>
        <i class="fa-duotone" [ngClass]="{'fa-caret-right': !treeControl.isExpanded(node), 'fa-caret-down': treeControl.isExpanded(node)}"></i>
      </button>
      <button *ngIf="node.selected && !node.isCaseRootNode" mat-flat-button (click)="folderClick(node)" class="selected-button">{{node.displayName}}</button>
      <div *ngIf="!node.selected && !node.isCaseRootNode" style="cursor: pointer;" (click)="folderClick(node)">{{node.displayName}}</div>
      <div *ngIf="node.isCaseRootNode" style="cursor: default;">{{node.displayName}}</div>
      <div *ngIf="node.isLoading">
        <i class="fa-duotone fa-folder-open loader"></i>
      </div>
    </mat-tree-node>
  </mat-tree>
  